import { productPhotoMetadata } from '@iheartjane/menu';
import {
  Box,
  Button,
  CheckFilledIcon,
  Flex,
  Typography,
} from '@iheartjane/reefer';
import { clsx } from 'clsx';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { monolithPaths as paths } from '@jane/shared/util';

import { DisplayMode, useProductCardContext } from '../productCardProvider';
import { ProductImage } from '../ProductImage';
import { MenuProductCardBackButton } from './backButton';
import { ProductPhotoCorner } from './editView';

import styles from './legacyMenuProductCard.module.css';

interface Props {
  height?: number | string;
}

export const MenuProductConfirmationView = ({ height }: Props) => {
  const { appMode, menuProduct, setDisplayMode } = useProductCardContext();
  const navigate = useNavigate();
  const photoMetadata = productPhotoMetadata(menuProduct);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDisplayMode(DisplayMode.Product);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Flex
      className={clsx(styles['cardContent'], styles['cardContent__focused'])}
      flexDirection="column"
      height={height}
      justifyContent="space-between"
    >
      <Box px={12} pt={12}>
        <MenuProductCardBackButton
          onClick={() => {
            setDisplayMode(DisplayMode.Product);
          }}
          productName={menuProduct?.name}
        />
      </Box>
      <Box
        className={styles['photoBox']}
        position="absolute"
        top={0}
        right={0}
        width={100}
        overflow="hidden"
        height={100}
        borderRadius="sm"
      >
        <ProductPhotoCorner />
        <ProductImage src={photoMetadata.url} alt={menuProduct?.name || ''} />
      </Box>
      <Flex
        flexDirection="column"
        position="absolute"
        left={0}
        right={0}
        top={100}
        alignItems="center"
      >
        <CheckFilledIcon size="lg" color="primary" />
        <Typography pt={8} pb={24} variant="body-semibold" textAlign="center">
          Bag updated!
        </Typography>
      </Flex>
      {(appMode === 'headless' || appMode === 'kiosk') && (
        <Flex px={4} mx={8} mb={16}>
          <Button
            onClick={() => navigate(paths.cart())}
            aria-label="proceed to bag"
            full
            label="Proceed to Bag"
          />
        </Flex>
      )}
    </Flex>
  );
};
